(function () {
  "use strict";

  var form       = document.getElementById("rfForm");
  var submitBtn  = document.getElementById("rfSubmitBtn");
  var btnText    = document.getElementById("rfBtnText");
  var btnLoader  = document.getElementById("rfBtnLoader");
  var successMsg = document.getElementById("rfSuccessMsg");
  var errorMsg   = document.getElementById("rfErrorMsg");
  var fileInput  = document.getElementById("rfHodFile");
  var fileName   = document.getElementById("rfFileName");

  var SHEET_URL = 'https://script.google.com/macros/s/AKfycbyyM2NcczWLY9o4AyupcoBVHYNYhbJjiVeycrs_gT5eswlsJ1U1tf-kCemgIVfVtfZ9_w/exec';

  /* ── File name display ───────────────────────── */
  fileInput.addEventListener("change", function () {
    fileName.textContent = fileInput.files.length > 0
      ? fileInput.files[0].name
      : "No file chosen";
    document.querySelector(".rf-file-wrap").classList.remove("rf-error");
  });

  /* ── UTM ──────────────────────────────────────── */
   function getUTM() {
    var p = new URLSearchParams(window.location.search);
    return {
      utm_source:   p.get('utm_source')   ? '- ' + p.get('utm_source')   : '- utm_source',
      utm_medium:   p.get('utm_medium')   ? '- ' + p.get('utm_medium')   : '- utm_medium',
      utm_campaign: p.get('utm_campaign') ? '- ' + p.get('utm_campaign') : '- utm_campaign',
      gclid:        p.get('gclid')        ? '- ' + p.get('gclid')        : '- gclid'
    };
  }

  /* ── Loading ──────────────────────────────────── */
  function setLoading(on) {
    submitBtn.disabled      = on;
    btnText.style.display   = on ? "none"         : "inline";
    btnLoader.style.display = on ? "inline-block" : "none";
  }

  /* ── Clear Errors ─────────────────────────────── */
  function clearErrors() {
    errorMsg.style.display = "none";
    form.querySelectorAll(".rf-error").forEach(function (el) {
      el.classList.remove("rf-error");
    });
  }

  /* ── Mark Error ───────────────────────────────── */
  function markError(el) {
    if (el) el.classList.add("rf-error");
  }

  /* ── Validate ─────────────────────────────────── */
  function validate(d) {
    var ok = true;

    if (!d.SalesName) { markError(document.getElementById("rfSalesName")); ok = false; }
    if (!d.Company)   { markError(document.getElementById("rfCompany"));   ok = false; }
    if (!d.Invoice)   { markError(document.getElementById("rfInvoice"));   ok = false; }
    if (!d.Model)     { markError(document.getElementById("rfModel"));     ok = false; }
    if (!d.Amount)    { markError(document.getElementById("rfAmount"));    ok = false; }
    if (!d.Material)  { markError(document.getElementById("rfMaterial"));  ok = false; }
    if (!d.HodName)   { markError(document.getElementById("rfHodName"));   ok = false; }
    if (!d.Reason)    { markError(document.getElementById("rfReason"));    ok = false; }

    // File required
    if (!fileInput.files || fileInput.files.length === 0) {
      document.querySelector(".rf-file-wrap").classList.add("rf-error");
      ok = false;
    }

    // Radio required
    if (!d.ReturnType) {
      document.getElementById("rfReturnTypeGroup").classList.add("rf-error");
      ok = false;
    }

    // Email format check (optional field)
    if (d.SalesEmail && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(d.SalesEmail)) {
      markError(document.getElementById("rfSalesEmail"));
      ok = false;
    }

    return ok;
  }

  /* ── Submit ───────────────────────────────────── */
  form.addEventListener("submit", function (e) {
    e.preventDefault();
    clearErrors();
    successMsg.style.display = "none";

    var selectedRadio = form.querySelector('input[name="ReturnType"]:checked');

    var data = {
      SalesName:  document.getElementById("rfSalesName").value.trim(),
      SalesEmail: document.getElementById("rfSalesEmail").value.trim(),
      Company:    document.getElementById("rfCompany").value.trim(),
      Invoice:    document.getElementById("rfInvoice").value.trim(),
      Model:      document.getElementById("rfModel").value.trim(),
      Amount:     document.getElementById("rfAmount").value.trim(),
      Material:   document.getElementById("rfMaterial").value,
      HodName:    document.getElementById("rfHodName").value.trim(),
      Reason:     document.getElementById("rfReason").value,
      ReturnType: selectedRadio ? selectedRadio.value : ""
    };

    if (!validate(data)) {
      errorMsg.textContent   = "❌ Please fill in all required fields.";
      errorMsg.style.display = "block";
      return;
    }

    var utm = getUTM();

    setLoading(true);

    // ── Send to Google Sheet ──────────────
    fetch(SHEET_URL, {
      method: 'POST',
      mode: 'no-cors',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        formName    : 'ReturnForm',
        sales_name  : data.SalesName,
        sales_email : data.SalesEmail,
        company     : data.Company,
        invoice     : data.Invoice,
        model       : data.Model,
        amount      : data.Amount,
        material    : data.Material,
        hod_name    : data.HodName,
        hod_file    : fileInput.files[0] ? fileInput.files[0].name : 'N/A',
        reason      : data.Reason,
        return_type : data.ReturnType,
        utm_source   : utm.utm_source,
        utm_medium   : utm.utm_medium,
        utm_campaign : utm.utm_campaign,
        gclid        : utm.gclid
      })
    })
      .then(function () {
        setLoading(false);
        form.reset();
        fileName.textContent = "No file chosen";
        form.querySelectorAll(".rf-row").forEach(function (el) {
          el.style.display = "none";
        });
        successMsg.style.display = "block";
      })
      .catch(function (err) {
        console.error("Submit Error:", err);
        setLoading(false);
        errorMsg.textContent   = "❌ Something went wrong. Please try again.";
        errorMsg.style.display = "block";
      });
  });

})();